/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminLoginRequest,
  AdminPasswordChangeRequest,
  AdminSessionEnvelope,
  AuthUserEnvelope,
  BeginBrowserLoginParams,
  CheckoutResponse,
  Commission,
  ConsultationCheckoutRequest,
  CreateCommissionRequest,
  CreateContactRequest,
  Design,
  DesignInput,
  DesignUpdate,
  ErrorEnvelope,
  HandleBrowserLoginCallbackParams,
  HealthStatus,
  InquiryRateLimitError,
  LogoutBrowserSessionParams,
  LogoutSuccess,
  MobileTokenExchangeRequest,
  MobileTokenExchangeSuccess,
  PartnerInquiryInput,
  PartnerInquirySuccess,
  PasswordChangeSuccess,
  Payment,
  PaymentCheckoutRequest,
  PublicConfig,
  SubmissionSuccess,
  UploadUrlRequest,
  UploadUrlResponse
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDesignsUrl = () => {




  return `/api/designs`
}

/**
 * @summary List architectural designs
 */
export const listDesigns = async ( options?: Parameters<typeof customFetch>[1]): Promise<Design[]> => {

  return customFetch<Design[]>(getListDesignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDesignsQueryKey = () => {
    return [
    `/api/designs`
    ] as const;
    }


export const getListDesignsQueryOptions = <TData = Awaited<ReturnType<typeof listDesigns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDesigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDesignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDesigns>>> = ({ signal }) => listDesigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDesigns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDesignsQueryResult = NonNullable<Awaited<ReturnType<typeof listDesigns>>>
export type ListDesignsQueryError = ErrorType<unknown>


/**
 * @summary List architectural designs
 */

export function useListDesigns<TData = Awaited<ReturnType<typeof listDesigns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDesigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDesignsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDesignUrl = () => {




  return `/api/designs`
}

/**
 * @summary Create an architectural design
 */
export const createDesign = async (designInput: DesignInput, options?: Parameters<typeof customFetch>[1]): Promise<Design> => {

  return customFetch<Design>(getCreateDesignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(designInput)
  }
);}





export const getCreateDesignMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDesign>>, TError,{data: BodyType<DesignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDesign>>, TError,{data: BodyType<DesignInput>}, TContext> => {

const mutationKey = ['createDesign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDesign>>, {data: BodyType<DesignInput>}> = (props) => {
          const {data} = props ?? {};

          return  createDesign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDesignMutationResult = NonNullable<Awaited<ReturnType<typeof createDesign>>>
    export type CreateDesignMutationBody = BodyType<DesignInput>
    export type CreateDesignMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Create an architectural design
 */
export const useCreateDesign = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDesign>>, TError,{data: BodyType<DesignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDesign>>,
        TError,
        {data: BodyType<DesignInput>},
        TContext
      > => {
      return useMutation(getCreateDesignMutationOptions(options));
    }

export const getGetDesignUrl = (number: number,) => {




  return `/api/designs/${number}`
}

/**
 * @summary Get a design by its collection number
 */
export const getDesign = async (number: number, options?: Parameters<typeof customFetch>[1]): Promise<Design> => {

  return customFetch<Design>(getGetDesignUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDesignQueryKey = (number: number,) => {
    return [
    `/api/designs/${number}`
    ] as const;
    }


export const getGetDesignQueryOptions = <TData = Awaited<ReturnType<typeof getDesign>>, TError = ErrorType<ErrorEnvelope>>(number: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDesign>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDesignQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDesign>>> = ({ signal }) => getDesign(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDesign>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDesignQueryResult = NonNullable<Awaited<ReturnType<typeof getDesign>>>
export type GetDesignQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Get a design by its collection number
 */

export function useGetDesign<TData = Awaited<ReturnType<typeof getDesign>>, TError = ErrorType<ErrorEnvelope>>(
 number: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDesign>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDesignQueryOptions(number,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDesignUrl = (number: number,) => {




  return `/api/designs/${number}`
}

/**
 * @summary Update a design
 */
export const updateDesign = async (number: number,
    designUpdate: DesignUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Design> => {

  return customFetch<Design>(getUpdateDesignUrl(number),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(designUpdate)
  }
);}





export const getUpdateDesignMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDesign>>, TError,{number: number;data: BodyType<DesignUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDesign>>, TError,{number: number;data: BodyType<DesignUpdate>}, TContext> => {

const mutationKey = ['updateDesign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDesign>>, {number: number;data: BodyType<DesignUpdate>}> = (props) => {
          const {number,data} = props ?? {};

          return  updateDesign(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDesignMutationResult = NonNullable<Awaited<ReturnType<typeof updateDesign>>>
    export type UpdateDesignMutationBody = BodyType<DesignUpdate>
    export type UpdateDesignMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Update a design
 */
export const useUpdateDesign = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDesign>>, TError,{number: number;data: BodyType<DesignUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDesign>>,
        TError,
        {number: number;data: BodyType<DesignUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDesignMutationOptions(options));
    }

export const getDeleteDesignUrl = (number: number,) => {




  return `/api/designs/${number}`
}

/**
 * @summary Delete a design
 */
export const deleteDesign = async (number: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteDesignUrl(number),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDesignMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDesign>>, TError,{number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDesign>>, TError,{number: number}, TContext> => {

const mutationKey = ['deleteDesign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDesign>>, {number: number}> = (props) => {
          const {number} = props ?? {};

          return  deleteDesign(number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDesignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDesign>>>

    export type DeleteDesignMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Delete a design
 */
export const useDeleteDesign = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDesign>>, TError,{number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDesign>>,
        TError,
        {number: number},
        TContext
      > => {
      return useMutation(getDeleteDesignMutationOptions(options));
    }

export const getCreateCommissionUrl = () => {




  return `/api/commissions`
}

/**
 * @summary Submit a custom design commission request
 */
export const createCommission = async (createCommissionRequest: CreateCommissionRequest, options?: Parameters<typeof customFetch>[1]): Promise<SubmissionSuccess> => {

  return customFetch<SubmissionSuccess>(getCreateCommissionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCommissionRequest)
  }
);}





export const getCreateCommissionMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCommission>>, TError,{data: BodyType<CreateCommissionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCommission>>, TError,{data: BodyType<CreateCommissionRequest>}, TContext> => {

const mutationKey = ['createCommission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCommission>>, {data: BodyType<CreateCommissionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createCommission(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCommissionMutationResult = NonNullable<Awaited<ReturnType<typeof createCommission>>>
    export type CreateCommissionMutationBody = BodyType<CreateCommissionRequest>
    export type CreateCommissionMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Submit a custom design commission request
 */
export const useCreateCommission = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCommission>>, TError,{data: BodyType<CreateCommissionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCommission>>,
        TError,
        {data: BodyType<CreateCommissionRequest>},
        TContext
      > => {
      return useMutation(getCreateCommissionMutationOptions(options));
    }

export const getListCommissionsUrl = () => {




  return `/api/commissions`
}

/**
 * @summary List commission requests for administrators
 */
export const listCommissions = async ( options?: Parameters<typeof customFetch>[1]): Promise<Commission[]> => {

  return customFetch<Commission[]>(getListCommissionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCommissionsQueryKey = () => {
    return [
    `/api/commissions`
    ] as const;
    }


export const getListCommissionsQueryOptions = <TData = Awaited<ReturnType<typeof listCommissions>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCommissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCommissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCommissions>>> = ({ signal }) => listCommissions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCommissions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCommissionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCommissions>>>
export type ListCommissionsQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary List commission requests for administrators
 */

export function useListCommissions<TData = Awaited<ReturnType<typeof listCommissions>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCommissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCommissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateContactUrl = () => {




  return `/api/contacts`
}

/**
 * @summary Submit a contact request
 */
export const createContact = async (createContactRequest: CreateContactRequest, options?: Parameters<typeof customFetch>[1]): Promise<SubmissionSuccess> => {

  return customFetch<SubmissionSuccess>(getCreateContactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createContactRequest)
  }
);}





export const getCreateContactMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContact>>, TError,{data: BodyType<CreateContactRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createContact>>, TError,{data: BodyType<CreateContactRequest>}, TContext> => {

const mutationKey = ['createContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContact>>, {data: BodyType<CreateContactRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContactMutationResult = NonNullable<Awaited<ReturnType<typeof createContact>>>
    export type CreateContactMutationBody = BodyType<CreateContactRequest>
    export type CreateContactMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Submit a contact request
 */
export const useCreateContact = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContact>>, TError,{data: BodyType<CreateContactRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createContact>>,
        TError,
        {data: BodyType<CreateContactRequest>},
        TContext
      > => {
      return useMutation(getCreateContactMutationOptions(options));
    }

export const getSubmitPartnerInquiryUrl = () => {




  return `/api/partner-inquiries`
}

/**
 * @summary Email a partnership or investment inquiry to One Exclusive Club
 */
export const submitPartnerInquiry = async (partnerInquiryInput: PartnerInquiryInput, options?: Parameters<typeof customFetch>[1]): Promise<PartnerInquirySuccess> => {

  return customFetch<PartnerInquirySuccess>(getSubmitPartnerInquiryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(partnerInquiryInput)
  }
);}





export const getSubmitPartnerInquiryMutationOptions = <TError = ErrorType<ErrorEnvelope | InquiryRateLimitError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPartnerInquiry>>, TError,{data: BodyType<PartnerInquiryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitPartnerInquiry>>, TError,{data: BodyType<PartnerInquiryInput>}, TContext> => {

const mutationKey = ['submitPartnerInquiry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitPartnerInquiry>>, {data: BodyType<PartnerInquiryInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitPartnerInquiry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitPartnerInquiryMutationResult = NonNullable<Awaited<ReturnType<typeof submitPartnerInquiry>>>
    export type SubmitPartnerInquiryMutationBody = BodyType<PartnerInquiryInput>
    export type SubmitPartnerInquiryMutationError = ErrorType<ErrorEnvelope | InquiryRateLimitError>

    /**
 * @summary Email a partnership or investment inquiry to One Exclusive Club
 */
export const useSubmitPartnerInquiry = <TError = ErrorType<ErrorEnvelope | InquiryRateLimitError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPartnerInquiry>>, TError,{data: BodyType<PartnerInquiryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitPartnerInquiry>>,
        TError,
        {data: BodyType<PartnerInquiryInput>},
        TContext
      > => {
      return useMutation(getSubmitPartnerInquiryMutationOptions(options));
    }

export const getGetPublicConfigUrl = () => {




  return `/api/public-config`
}

/**
 * @summary Get public pricing configuration
 */
export const getPublicConfig = async ( options?: Parameters<typeof customFetch>[1]): Promise<PublicConfig> => {

  return customFetch<PublicConfig>(getGetPublicConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicConfigQueryKey = () => {
    return [
    `/api/public-config`
    ] as const;
    }


export const getGetPublicConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPublicConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicConfig>>> = ({ signal }) => getPublicConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicConfig>>>
export type GetPublicConfigQueryError = ErrorType<unknown>


/**
 * @summary Get public pricing configuration
 */

export function useGetPublicConfig<TData = Awaited<ReturnType<typeof getPublicConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePaymentCheckoutUrl = () => {




  return `/api/payments/checkout`
}

/**
 * @summary Create a design payment checkout
 */
export const createPaymentCheckout = async (paymentCheckoutRequest: PaymentCheckoutRequest, options?: Parameters<typeof customFetch>[1]): Promise<CheckoutResponse | ErrorEnvelope> => {

  return customFetch<CheckoutResponse | ErrorEnvelope>(getCreatePaymentCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(paymentCheckoutRequest)
  }
);}





export const getCreatePaymentCheckoutMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentCheckout>>, TError,{data: BodyType<PaymentCheckoutRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPaymentCheckout>>, TError,{data: BodyType<PaymentCheckoutRequest>}, TContext> => {

const mutationKey = ['createPaymentCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPaymentCheckout>>, {data: BodyType<PaymentCheckoutRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createPaymentCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentCheckout>>>
    export type CreatePaymentCheckoutMutationBody = BodyType<PaymentCheckoutRequest>
    export type CreatePaymentCheckoutMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Create a design payment checkout
 */
export const useCreatePaymentCheckout = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentCheckout>>, TError,{data: BodyType<PaymentCheckoutRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPaymentCheckout>>,
        TError,
        {data: BodyType<PaymentCheckoutRequest>},
        TContext
      > => {
      return useMutation(getCreatePaymentCheckoutMutationOptions(options));
    }

export const getCreateConsultationCheckoutUrl = () => {




  return `/api/consultations/checkout`
}

/**
 * @summary Create a consultation checkout
 */
export const createConsultationCheckout = async (consultationCheckoutRequest: ConsultationCheckoutRequest, options?: Parameters<typeof customFetch>[1]): Promise<CheckoutResponse | ErrorEnvelope> => {

  return customFetch<CheckoutResponse | ErrorEnvelope>(getCreateConsultationCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(consultationCheckoutRequest)
  }
);}





export const getCreateConsultationCheckoutMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConsultationCheckout>>, TError,{data: BodyType<ConsultationCheckoutRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createConsultationCheckout>>, TError,{data: BodyType<ConsultationCheckoutRequest>}, TContext> => {

const mutationKey = ['createConsultationCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConsultationCheckout>>, {data: BodyType<ConsultationCheckoutRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createConsultationCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConsultationCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof createConsultationCheckout>>>
    export type CreateConsultationCheckoutMutationBody = BodyType<ConsultationCheckoutRequest>
    export type CreateConsultationCheckoutMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Create a consultation checkout
 */
export const useCreateConsultationCheckout = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConsultationCheckout>>, TError,{data: BodyType<ConsultationCheckoutRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createConsultationCheckout>>,
        TError,
        {data: BodyType<ConsultationCheckoutRequest>},
        TContext
      > => {
      return useMutation(getCreateConsultationCheckoutMutationOptions(options));
    }

export const getListPaymentsUrl = () => {




  return `/api/payments`
}

/**
 * @summary List recent payments for administrators
 */
export const listPayments = async ( options?: Parameters<typeof customFetch>[1]): Promise<Payment[]> => {

  return customFetch<Payment[]>(getListPaymentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPaymentsQueryKey = () => {
    return [
    `/api/payments`
    ] as const;
    }


export const getListPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listPayments>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayments>>> = ({ signal }) => listPayments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayments>>>
export type ListPaymentsQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary List recent payments for administrators
 */

export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPaymentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * Returns a presigned URL for a direct upload to App Storage.
 * @summary Request a presigned URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: Parameters<typeof customFetch>[1]): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}





export const getRequestUploadUrlMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getGetPublicObjectUrl = (filePath: string,) => {




  return `/api/storage/public-objects/${filePath}`
}

/**
 * @summary Serve a public asset
 */
export const getPublicObject = async (filePath: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetPublicObjectUrl(filePath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicObjectQueryKey = (filePath: string,) => {
    return [
    `/api/storage/public-objects/${filePath}`
    ] as const;
    }


export const getGetPublicObjectQueryOptions = <TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({ signal }) => getPublicObject(filePath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: filePath !== null && filePath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicObject>>>
export type GetPublicObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve a public asset
 */

export function useGetPublicObject<TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(
 filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicObjectQueryOptions(filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * @summary Serve an uploaded design asset
 */
export const getStorageObject = async (objectPath: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve an uploaded design asset
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminSessionUrl = () => {




  return `/api/admin/session`
}

/**
 * @summary Get the current dedicated admin session
 */
export const getAdminSession = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminSessionEnvelope> => {

  return customFetch<AdminSessionEnvelope>(getGetAdminSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminSessionQueryKey = () => {
    return [
    `/api/admin/session`
    ] as const;
    }


export const getGetAdminSessionQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSession>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSession>>> = ({ signal }) => getAdminSession({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSession>>>
export type GetAdminSessionQueryError = ErrorType<unknown>


/**
 * @summary Get the current dedicated admin session
 */

export function useGetAdminSession<TData = Awaited<ReturnType<typeof getAdminSession>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSessionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLoginAdminUrl = () => {




  return `/api/admin/session`
}

/**
 * @summary Sign in to the dedicated catalogue admin account
 */
export const loginAdmin = async (adminLoginRequest: AdminLoginRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminSessionEnvelope> => {

  return customFetch<AdminSessionEnvelope>(getLoginAdminUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminLoginRequest)
  }
);}





export const getLoginAdminMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginAdmin>>, TError,{data: BodyType<AdminLoginRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof loginAdmin>>, TError,{data: BodyType<AdminLoginRequest>}, TContext> => {

const mutationKey = ['loginAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginAdmin>>, {data: BodyType<AdminLoginRequest>}> = (props) => {
          const {data} = props ?? {};

          return  loginAdmin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginAdminMutationResult = NonNullable<Awaited<ReturnType<typeof loginAdmin>>>
    export type LoginAdminMutationBody = BodyType<AdminLoginRequest>
    export type LoginAdminMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Sign in to the dedicated catalogue admin account
 */
export const useLoginAdmin = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginAdmin>>, TError,{data: BodyType<AdminLoginRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof loginAdmin>>,
        TError,
        {data: BodyType<AdminLoginRequest>},
        TContext
      > => {
      return useMutation(getLoginAdminMutationOptions(options));
    }

export const getLogoutAdminUrl = () => {




  return `/api/admin/session`
}

/**
 * @summary End the dedicated admin session
 */
export const logoutAdmin = async ( options?: Parameters<typeof customFetch>[1]): Promise<LogoutSuccess> => {

  return customFetch<LogoutSuccess>(getLogoutAdminUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLogoutAdminMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAdmin>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutAdmin>>, TError,void, TContext> => {

const mutationKey = ['logoutAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutAdmin>>, void> = () => {


          return  logoutAdmin(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutAdminMutationResult = NonNullable<Awaited<ReturnType<typeof logoutAdmin>>>

    export type LogoutAdminMutationError = ErrorType<unknown>

    /**
 * @summary End the dedicated admin session
 */
export const useLogoutAdmin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAdmin>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutAdmin>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutAdminMutationOptions(options));
    }

export const getChangeAdminPasswordUrl = () => {




  return `/api/admin/password`
}

/**
 * @summary Change the dedicated administrator password
 */
export const changeAdminPassword = async (adminPasswordChangeRequest: AdminPasswordChangeRequest, options?: Parameters<typeof customFetch>[1]): Promise<PasswordChangeSuccess> => {

  return customFetch<PasswordChangeSuccess>(getChangeAdminPasswordUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminPasswordChangeRequest)
  }
);}





export const getChangeAdminPasswordMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeAdminPassword>>, TError,{data: BodyType<AdminPasswordChangeRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeAdminPassword>>, TError,{data: BodyType<AdminPasswordChangeRequest>}, TContext> => {

const mutationKey = ['changeAdminPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeAdminPassword>>, {data: BodyType<AdminPasswordChangeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  changeAdminPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeAdminPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changeAdminPassword>>>
    export type ChangeAdminPasswordMutationBody = BodyType<AdminPasswordChangeRequest>
    export type ChangeAdminPasswordMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Change the dedicated administrator password
 */
export const useChangeAdminPassword = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeAdminPassword>>, TError,{data: BodyType<AdminPasswordChangeRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof changeAdminPassword>>,
        TError,
        {data: BodyType<AdminPasswordChangeRequest>},
        TContext
      > => {
      return useMutation(getChangeAdminPasswordMutationOptions(options));
    }

export const getGetCurrentAuthUserUrl = () => {




  return `/api/auth/user`
}

/**
 * @summary Get the currently authenticated user
 */
export const getCurrentAuthUser = async ( options?: Parameters<typeof customFetch>[1]): Promise<AuthUserEnvelope> => {

  return customFetch<AuthUserEnvelope>(getGetCurrentAuthUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentAuthUserQueryKey = () => {
    return [
    `/api/auth/user`
    ] as const;
    }


export const getGetCurrentAuthUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentAuthUser>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentAuthUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentAuthUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentAuthUser>>> = ({ signal }) => getCurrentAuthUser({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentAuthUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentAuthUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentAuthUser>>>
export type GetCurrentAuthUserQueryError = ErrorType<unknown>


/**
 * @summary Get the currently authenticated user
 */

export function useGetCurrentAuthUser<TData = Awaited<ReturnType<typeof getCurrentAuthUser>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentAuthUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentAuthUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBeginBrowserLoginUrl = (params?: BeginBrowserLoginParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/login?${stringifiedParams}` : `/api/login`
}

/**
 * @summary Start the browser login flow
 */
export const beginBrowserLogin = async (params?: BeginBrowserLoginParams, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getBeginBrowserLoginUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBeginBrowserLoginQueryKey = (params?: BeginBrowserLoginParams,) => {
    return [
    `/api/login`, ...(params ? [params] : [])
    ] as const;
    }


export const getBeginBrowserLoginQueryOptions = <TData = Awaited<ReturnType<typeof beginBrowserLogin>>, TError = ErrorType<void>>(params?: BeginBrowserLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof beginBrowserLogin>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBeginBrowserLoginQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof beginBrowserLogin>>> = ({ signal }) => beginBrowserLogin(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof beginBrowserLogin>>, TError, TData> & { queryKey: QueryKey }
}

export type BeginBrowserLoginQueryResult = NonNullable<Awaited<ReturnType<typeof beginBrowserLogin>>>
export type BeginBrowserLoginQueryError = ErrorType<void>


/**
 * @summary Start the browser login flow
 */

export function useBeginBrowserLogin<TData = Awaited<ReturnType<typeof beginBrowserLogin>>, TError = ErrorType<void>>(
 params?: BeginBrowserLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof beginBrowserLogin>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getBeginBrowserLoginQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getHandleBrowserLoginCallbackUrl = (params?: HandleBrowserLoginCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/callback?${stringifiedParams}` : `/api/callback`
}

/**
 * @summary Complete browser login
 */
export const handleBrowserLoginCallback = async (params?: HandleBrowserLoginCallbackParams, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getHandleBrowserLoginCallbackUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHandleBrowserLoginCallbackQueryKey = (params?: HandleBrowserLoginCallbackParams,) => {
    return [
    `/api/callback`, ...(params ? [params] : [])
    ] as const;
    }


export const getHandleBrowserLoginCallbackQueryOptions = <TData = Awaited<ReturnType<typeof handleBrowserLoginCallback>>, TError = ErrorType<void>>(params?: HandleBrowserLoginCallbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof handleBrowserLoginCallback>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHandleBrowserLoginCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof handleBrowserLoginCallback>>> = ({ signal }) => handleBrowserLoginCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof handleBrowserLoginCallback>>, TError, TData> & { queryKey: QueryKey }
}

export type HandleBrowserLoginCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof handleBrowserLoginCallback>>>
export type HandleBrowserLoginCallbackQueryError = ErrorType<void>


/**
 * @summary Complete browser login
 */

export function useHandleBrowserLoginCallback<TData = Awaited<ReturnType<typeof handleBrowserLoginCallback>>, TError = ErrorType<void>>(
 params?: HandleBrowserLoginCallbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof handleBrowserLoginCallback>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHandleBrowserLoginCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLogoutBrowserSessionUrl = (params?: LogoutBrowserSessionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/logout?${stringifiedParams}` : `/api/logout`
}

/**
 * @summary Log out the current user
 */
export const logoutBrowserSession = async (params?: LogoutBrowserSessionParams, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getLogoutBrowserSessionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogoutBrowserSessionQueryKey = (params?: LogoutBrowserSessionParams,) => {
    return [
    `/api/logout`, ...(params ? [params] : [])
    ] as const;
    }


export const getLogoutBrowserSessionQueryOptions = <TData = Awaited<ReturnType<typeof logoutBrowserSession>>, TError = ErrorType<void>>(params?: LogoutBrowserSessionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof logoutBrowserSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLogoutBrowserSessionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logoutBrowserSession>>> = ({ signal }) => logoutBrowserSession(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logoutBrowserSession>>, TError, TData> & { queryKey: QueryKey }
}

export type LogoutBrowserSessionQueryResult = NonNullable<Awaited<ReturnType<typeof logoutBrowserSession>>>
export type LogoutBrowserSessionQueryError = ErrorType<void>


/**
 * @summary Log out the current user
 */

export function useLogoutBrowserSession<TData = Awaited<ReturnType<typeof logoutBrowserSession>>, TError = ErrorType<void>>(
 params?: LogoutBrowserSessionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof logoutBrowserSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getLogoutBrowserSessionQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExchangeMobileAuthorizationCodeUrl = () => {




  return `/api/mobile-auth/token-exchange`
}

/**
 * @summary Exchange a mobile authorization code
 */
export const exchangeMobileAuthorizationCode = async (mobileTokenExchangeRequest: MobileTokenExchangeRequest, options?: Parameters<typeof customFetch>[1]): Promise<MobileTokenExchangeSuccess> => {

  return customFetch<MobileTokenExchangeSuccess>(getExchangeMobileAuthorizationCodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mobileTokenExchangeRequest)
  }
);}





export const getExchangeMobileAuthorizationCodeMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeMobileAuthorizationCode>>, TError,{data: BodyType<MobileTokenExchangeRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof exchangeMobileAuthorizationCode>>, TError,{data: BodyType<MobileTokenExchangeRequest>}, TContext> => {

const mutationKey = ['exchangeMobileAuthorizationCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exchangeMobileAuthorizationCode>>, {data: BodyType<MobileTokenExchangeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  exchangeMobileAuthorizationCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExchangeMobileAuthorizationCodeMutationResult = NonNullable<Awaited<ReturnType<typeof exchangeMobileAuthorizationCode>>>
    export type ExchangeMobileAuthorizationCodeMutationBody = BodyType<MobileTokenExchangeRequest>
    export type ExchangeMobileAuthorizationCodeMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Exchange a mobile authorization code
 */
export const useExchangeMobileAuthorizationCode = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeMobileAuthorizationCode>>, TError,{data: BodyType<MobileTokenExchangeRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof exchangeMobileAuthorizationCode>>,
        TError,
        {data: BodyType<MobileTokenExchangeRequest>},
        TContext
      > => {
      return useMutation(getExchangeMobileAuthorizationCodeMutationOptions(options));
    }

export const getLogoutMobileSessionUrl = () => {




  return `/api/mobile-auth/logout`
}

/**
 * @summary Log out a mobile session
 */
export const logoutMobileSession = async ( options?: Parameters<typeof customFetch>[1]): Promise<LogoutSuccess> => {

  return customFetch<LogoutSuccess>(getLogoutMobileSessionUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMobileSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutMobileSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutMobileSession>>, TError,void, TContext> => {

const mutationKey = ['logoutMobileSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutMobileSession>>, void> = () => {


          return  logoutMobileSession(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMobileSessionMutationResult = NonNullable<Awaited<ReturnType<typeof logoutMobileSession>>>

    export type LogoutMobileSessionMutationError = ErrorType<unknown>

    /**
 * @summary Log out a mobile session
 */
export const useLogoutMobileSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutMobileSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutMobileSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMobileSessionMutationOptions(options));
    }

